/* eslint-disable quotes */
// Grego
export const grego = {
  start: "Εκκίνηση",
  configurations: "Ρυθμίσεις",
  ramdom: "Λειτουργία τυχαίας αναπαραγωγής",
  vibration: "Δονήσεις :",
  startgame: "Έναρξη παιχνιδιού",
  save: "Αποθήκευση",
  delete: "Διαγραφή",
  update: "Ενημέρωση",
  lets: "Ας παίξουμε",
  permanentbuy: "Μόνιμες αγορές",
  signature: "Μηνιαία συνδρομή",
  signatureano: "Ετήσια συνδρομή",
  small:
    "Εδώ μπορείτε να χρησιμοποιήσετε το πραγματικό σας όνομα... ή ένα ψευδώνυμο :)",
  text1: "Αποκτήστε premium πρόσβαση και εγγυηθείτε όλες τις ενημερώσεις",
  text2:
    "Με την εγγραφή σας μπορείτε να έχετε πρόσβαση στην έκδοση Premium όποτε θέλετε.",
  gender: "Φύλο",
  male: "Αρσενικό  ",
  female: "Γυναίκα",
  ambos: "Και οι δύο",
  fechar: "Κλείσιμο",
  sexualorientation: "Σεξουαλικός προσανατολισμός",
  heterosexual: "Ετεροφυλόφιλοι",
  homosexual: "Ομοφυλόφιλοι",
  bisexual: "Αμφιφυλόφιλος",
  chooseavatar: "Επιλέξτε το avatar σας",
  Participants: "Συμμετέχοντες",
  participant: "Εγγραφή συμμετεχόντων",
  name: "Όνομα",
  choosecategory: "Επιλέξτε κατηγορίες",
  categories: "Κατηγορίες",
  light: "Φως",
  preliminary: "Προκαταρκτικά",
  oral: "Στοματικό",
  anal: "Πρωκτικό",
  hot: "Καυτό",
  extreme: "Ακραία",
  vd: "Αλήθεια ?",
  dare: "Προκλήσεις ?",
  truth: "Αλήθεια",
  time: "Χρόνος",
  createMyChallenges: "Δημιουργήστε τις προκλήσεις μου",
  chosen: "Επιλεγμένα",
  text3: "Αφήστε την αγάπη να ρέει μέσα σας!",
  text4: "Ετοιμαστείτε να ζήσετε έντονα",
  close: "Κλείσιμο",
  sele: "Επιλέξτε μια επιλογή",
  dev: "Αναπτύχθηκε από Dev12BR",
  game: "Παιχνίδι",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "ΕΠΟΜΕΝΟ",
  config1: "Γιατί να αγοράσω την έκδοση Premium;",
  config2: "Αποκλειστικές κατηγορίες και πάνω από 800 νέες προκλήσεις",
  config3: "Χωρίς διαφημίσεις",
  config4: "Επιλέξτε avatars για να ενισχύσετε",
  config5: "Δημιουργήστε τις δικές σας προκλήσεις ",
  config6: "Υποστηρίζετε την ανάπτυξη παιχνιδιών",
  config7: "Γιατί το παιχνίδι έχει κόστος;",
  config8:
    "Για να αναπτύξετε το παιχνίδι χρειάζεστε χρόνο! :) Με αυτόν τον τρόπο υποστηρίζετε το παιχνίδι και μας βοηθάτε να βελτιώνουμε και να ενημερώνουμε πάντα το παιχνίδι.",
  config9: "Δημιουργήστε τις δικές σας προκλήσεις",
  age: `Αυτό το παιχνίδι είναι μόνο για ενήλικες, επομένως πρέπει να είστε τουλάχιστον 18 ετών. Επιλέγοντας "Ναι", συμφωνείτε με τους όρους χρήσης και την πολιτική απορρήτου. 

    Αυτό το παιχνίδι είναι κατάλληλο για ζευγάρια, οπότε πρέπει να παίξετε με τουλάχιστον έναν σύντροφο. 
    
    Δεν πρόκειται για εφαρμογή γνωριμιών, αλλά για έναν τρόπο να παίζετε με τον σύντροφό σας.
    `,
  config10: "Αποκλειστικές κατηγορίες",
  config11: "+ 800 νέες προκλήσεις",
  assessment:
    "Παρακαλώ βαθμολογήστε το προσθέτοντας ένα σχόλιο για την εφαρμογή. Τα σχόλιά σας είναι πολύ σημαντικά για εμάς, προκειμένου να διατηρήσουμε το παιχνίδι όσο το δυνατόν καλύτερο.",
  agree: "Ναι, είμαι άνω των 18 ετών",
  noAgree: "Κλείστε την εφαρμογή",
  apoio1: "Υποστηρίξτε την ανάπτυξη κάνοντας συνδρομή στην έκδοση Premium :)",
  apoio2: "Μην ξεχάσετε να βαθμολογήσετε την εφαρμογή στο κατάστημα S2",
  apoio3:
    "Αποκτήστε πρόσβαση σε όλες τις αποκλειστικές λειτουργίες της έκδοσης Premium",
  apoio4: "Απαλλαγείτε από αυτό το banner - Αγοράστε την έκδοση Premium",
  version: "Έκδοση Premium",
  version1: "Έκδοση Premium 🏆",
  alert1: "Εγγραφή χρηστών για να παίξουν",
  alert2: "Καταχωρήστε τουλάχιστον έναν ακόμη χρήστη για να παίξετε",
  alert3: "Επιλέξτε τουλάχιστον μία κατηγορία",
  alert4: `🔥 Υπάρχουν συμμετέχοντες χωρίς εταίρους. Να υπάρχουν τουλάχιστον δύο συμμετέχοντες για κάθε φύλο 🔞. 
        
Παράδειγμα: Δύο ετεροφυλόφιλοι ή 2 ομοφυλόφιλοι.`,
  tituloAlert1: "⚠️ Το παιχνίδι πρόκειται να ξεκινήσει 😜",
  tituloAlert2:
    "⚠️ Κρίμα 😬, είστε χωρίς διαδίκτυο 📶. Ενεργοποιήστε το διαδίκτυο στη συσκευή σας και αγοράστε τη συνδρομή ή το οριστικό πρόγραμμα. Και να είσαι ευτυχισμένος😘.",
  parser: "Δεν υπάρχει εταίρος",
  premiumImages: "Γίνετε Premium και αποκτήστε πρόσβαση σε περισσότερα avatars",
  duvidas: "Ερωτήσεις ή προτάσεις - Πικάντικες προκλήσεις",
  description: "Γεια σας, η ερώτηση ή η πρότασή μου είναι :",
  texto99:
    "Εάν έχετε οποιαδήποτε προβλήματα, ερωτήσεις ή προτάσεις, παρακαλούμε στείλτε μας ένα email κάνοντας κλικ σε αυτό το κουμπί παρακάτω. Ανυπομονούμε να μιλήσουμε μαζί σας!",
  send: "Στείλτε ✉️",
  contact: "Επικοινωνία",
  botaoApple: "Επαναφορά αγορών",
  alertCompra: "Η αγορά σας επαναφέρεται",
  NotPurchase: "Δεν έχετε αγορές",
  notPurchase2:
    "Αυτός ο σύνδεσμος είναι μόνο για χρήστες που έχουν αγοράσει προηγούμενες αγορές και θέλουν να τις επαναφέρουν σε μια νέα συσκευή.",
  termOfPotitic: "Όροι χρήσης και Πολιτική απορρήτου",
  alertDeuErrado: "Κάτι πήγε στραβά :(",
  alertDeuErrado2: "Συμπληρώστε όλες τις πληροφορίες",
  alertNome: "Συμπληρώστε το πεδίο: Όνομα",
  options: "επιλογές",
  optionsTitle: "επιλογές",
  gradualGame: "Σταδιακό παιχνίδι",
  textoCaixa:
    "Ενεργοποιώντας αυτή την επιλογή, οι προκλήσεις θα είναι σταδιακές, δηλαδή από την πιο ελαφριά στην πιο ακραία ανάλογα με την επιλογή σας.",
  comoJogar: "Πώς να παίξετε? 🤔",
  avalie: "Αξιολογήστε το",
  novaCategoria: "Οι κατηγορίες μου",
  alterLanguage: "Αλλαγή γλώσσας ?",
  textLanguage: "Κατά την αλλαγή της γλώσσας η εφαρμογή θα κάνει επανεκκίνηση",
  textLanguage1: "Αλλαγή γλώσσας",
  cancel: "Ακύρωση",
  languages: "Γλώσσες",
  email: "@email ✉️",
  deletCat: "Διαγραφή κατηγορίας",
  textDeletCat:
    "Με τη διαγραφή αυτής της κατηγορίας, θα διαγραφούν οι προκλήσεις αυτής της κατηγορίας. Μετά την ενέργεια αυτή δεν μπορεί πλέον να αναιρεθεί.",
  deletDes: "Διαγράψτε την πρόκληση",
  textDeletDes:
    "Μετά τη διαγραφή της πρόκλησης αυτή η ενέργεια δεν μπορεί πλέον να αναιρεθεί.",
  desafio: "Εγγραφή νέας πρόκλησης",
  desafiotexto: "Πρόκληση",
  textoeditDesafio: "Ποιος μπορεί να το κάνει αυτό;",
  textEmquem: "Σε ποιον ?",
  nome: "Όνομα",
  inicio: "Ξεκινώντας το παιχνίδι",
  inicio2:
    "Πατώντας αυτό το κουμπί θα μεταφερθείτε στην οθόνη εγγραφής παικτών. 👥.",
  inicio3: "Το παιχνίδι πρόκειται να ξεκινήσει 🎲",
  inicio4: "Επόμενο",
  inicio5: "Ρυθμίσεις",
  inicio6: `Ρυθμίσεις όπως: 
  
- Προοδευτικές προκλήσεις
- Αλλαγή της γλώσσας των προκλήσεων 
- Δημιουργία προκλήσεων 
- Υποστήριξη 
- Μεταξύ άλλων.`,
  inicio7: "Τέλος",
  inicio8: `Γίνετε Premium και αποκτήστε πρόσβαση σε:

- 450 νέες προκλήσεις 😎

- Αποκλειστικοί χαρακτήρες 🦸♀️ 🧑🚒
  
- Δημιουργήστε τις δικές σας προκλήσεις 📝
  
- Κρατήστε το παιχνίδι ενημερωμένο ✅
  
- Και πολλά άλλα 😍`,
  inicio9: "Βοήθεια",
  inicio10: "Καλώς ήρθατε στο παιχνίδι Spicy Challenges 🌶",
  inicio11:
    "Δείτε πόσο εύκολο είναι να παίξετε και να πλοηγηθείτε στα μενού σε λιγότερο από 30 δευτερόλεπτα. 😎.",
  inicio12: "Προβολή σεμιναρίου 👍🏼",
  inicio13: "Δεν θέλω να 👎🏼",
  inicio14: `Για να ξεκινήσετε το παιχνίδι, πρέπει να προσθέσετε τουλάχιστον (2) δύο παίκτες. 😀
              
Πατώντας το κουμπί που υποδεικνύεται παραπάνω 👆
  
Κάθε φορά που προσθέτετε έναν νέο χρήστη πατήστε το ίδιο κουμπί😘`,
  cadastrarCategory: "Κατηγορία εγγραφής",
  inicio15: "Δημιουργία νέας κατηγορίας",
  inicio16:
    "Βήμα 1 : Πατήστε το κουμπί με το σύμβολο + που βρίσκεται στο κάτω μέρος αυτής της οθόνης. Αφού πατήσετε το πλήκτρο, θα εμφανιστεί ένα παράθυρο για να εισάγετε τη νέα σας κατηγορία.",
  inicio17: "Βήμα 2: Εισάγετε τη νέα σας κατηγορία και πατήστε αποθήκευση",
  inicio18:
    "Βήμα 3: Για να επεξεργαστείτε αυτή την κατηγορία ή να ΠΡΟΣΘΕΤΕΣΤΕ τις προκλήσεις εντός της κατηγορίας, κάντε κλικ σε αυτήν.",
  inicio19:
    "Βήμα 4: Στην επόμενη οθόνη, πατώντας το κουμπί που υποδεικνύεται με το βέλος ⬆️ θα ανοίξει ένα παράθυρο για την επεξεργασία της νέας σας κατηγορίας.",
  inicio20:
    "Βήμα 5: Στην επόμενη οθόνη, πατώντας το κουμπί που υποδεικνύεται με το βέλος ⬆️, θα διαγράψετε την κατηγορία.",
  inicio21:
    "Βήμα 1: Πατήστε το παρακάτω κουμπί για να προσθέσετε μια νέα πρόκληση σε αυτή την κατηγορία",
  inicio22: "Δημιουργία μιας νέας πρόκλησης",
  inicio23:
    "Βήμα 2: Κάντε κλικ σε κάθε κυκλωμένο στοιχείο για να μάθετε λεπτομερώς κάθε πεδίο του μητρώου.",
  inicio24: "Κείμενο της πρόκλησης",
  inicio25: `Γράψτε την πρόκληση της αρεσκείας σας και για να εμφανιστεί το όνομα του παίκτη στην πρόκληση, απλά πατήστε το κόκκινο κουμπί παρακάτω. 
    
Θα προσθέσει τους ακόλουθους χαρακτήρες {nome}. 

** ΜΗΝ ΑΛΛΑΞΕΤΕ ΑΥΤΟΥΣ ΤΟΥΣ ΣΤΟΙΧΕΙΑ ** Επειδή για να εμφανιστεί το όνομα αναλόγως, πρέπει να είναι όπως περιγράφεται παρακάτω ⬇️⬇️⬇️⬇️⬇️⬇️

Πρόκληση: Φιλήστε το λαιμό του {nome}`,
  inicio26: "Ποιος μπορεί να κάνει και ποιος μπορεί να λάβει",
  inicio27: `Επιλέξτε "Και τα δύο" εάν η πρόκληση μπορεί να εκτελεστεί και να ληφθεί από συμμετέχοντες "και των δύο" φύλων.
  
Αν η πρόκληση απευθύνεται σε ένα είδος, απλά επιλέξτε το επιθυμητό.
`,
  inicio28: "Προσθέτοντας χρόνο στην πρόκληση",
  inicio29:
    'Αν η πρόκλησή σας έχει χρόνο, απλά σύρετε το "εύρος" παρακάτω και η τιμή θα εμφανιστεί παραπάνω. Όταν λήξει ο χρόνος της πρόκλησης, θα ακουστεί ένας ήχος που θα σας ενημερώσει ότι η πρόκληση έχει τελειώσει.',
  aviso12: `Εδώ δημιουργείτε μόνο την κατηγορία!
    
Για να προσθέσετε τις προκλήσεις απλά πατήστε το κουμπί της κατηγορίας σας που μόλις δημιουργήθηκε ⬆️⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Επιστροφή",
  semDe: "Παίκτης χωρίς εγγεγραμμένη πρόκληση",
  semDe2: `Καταχωρήστε τουλάχιστον μία πρόκληση για αυτόν τον παίκτη 😬. 
  
Θα μεταφερθείτε στην οθόνη σύνδεσης.`,
  term: "Απόρρητο",
  Potitic: "Όροι χρήσης",
  adquirited: "Αποκτημένο",
  camera: "Κάμερα",
  galery: "Γκαλερί",
  avatar: "Avatar",
  image: "Άβαταρ",
  seletion: " Επιλεγμένα",
  editCategory: "Επεξεργαστείτε την κατηγορία",
  frase1: "Απολαμβάνεις τις προκλήσεις;",
  frase2: "Τι θα λέγατε να δοκιμάσετε τις Προκλήσεις Premium?",
  //err texto

  errTexto:
    "Αν διαπιστώσατε κάποιο μεταφραστικό λάθος, διορθώστε τη φράση στο παρακάτω πεδίο:",
  errTitulo: "Παρατηρήσατε κάτι λάθος;",
  errCorrect: "Πώς θα ήταν στα ελληνικά;",
  thisLanguageIsCorrect: "Η πρόκληση στα ΕΛΛΗΝΙΚΑ είναι σωστή;",
  yes: "Ναι",
  no: "Όχι",
  errSend: "Στείλτε πρόταση",

  share: "μερίδιο",
  fraseShare: `Τι κορυφαία εφαρμογή! Απλά το μοιράζομαι γιατί ξέρω ότι θα σας αρέσει κι εσάς!🫣
  Κατεβάστε το και μετά πείτε μου αν δεν είναι πολύ καλό lol...😉
  
  
  Σύνδεσμος για λήψη: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇬🇷",

  morePlayer: "Παίζοντας με περισσότερους παίκτες ?",
  players: "Παίκτες",
  carregar: "ανεβάστε εικόνα",
  takePhoto: "Τραβήξτε μια φωτογραφία ή επιλέξτε μια εικόνα",
  useAvatar: "Ή χρησιμοποιήστε Avatars",

  hetero: "Στρέιτ ζευγάρι",
  gay: "Ζευγάρι ομοφυλόφιλων",
  lesbico: "Λεσβιακό ζευγάρι",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Προσθέστε τους παίκτες 🙌",
  descricaoErr: "Εισάγετε τα ονόματα των συμμετεχόντων ✍️",
  why: "Πείτε μας γιατί...",
  later: "Αξιολογήστε αργότερα",
  txtCard1: "Σειρά σου 🔥",
  txtCard2: "Make it happen 😘",
  txtCard3: "Come on! 😜",
  txtCard4: "Επόμενη πρόκληση 😈",
  txtCard5: "Ένα ακόμα! 👄",

  tituloBloco1Novo: "Εξερευνήστε τη σεξουαλική οικειότητα με τον σύντροφό σας",
  subtitulo1Novo: "Περισσότεροι από 1 εκατομμύριο ευτυχισμένοι ζευγάρια",
  texto1Novo:
    "Εξερευνήστε την οικειότητα μεταξύ εσάς και του συντρόφου σας και αποκτήστε πρόσβαση στα καλύτερα παιχνίδια για ζευγάρια! Ξεκλειδώστε τώρα όλα τα παιχνίδια με διάφορες κατηγορίες που έχουν σχεδιαστεί για εσάς για να βελτιώσετε τη σύνδεση με την αγάπη σας!",

  tituloBloco2Novo: "Νέες εμπειρίες και μια καλύτερη σχέση",
  texto2Novo1: "Απολαύστε πάνω από 1500 προκλήσεις",
  texto2Novo2: "Δημιουργήστε τις δικές σας προκλήσεις",
  texto2Novo3: "Αποκλειστικές κατηγορίες",
  texto2Novo4: "Χωρίς διαφημίσεις",
  texto2Novo5: "Αποκλειστικά Avatars",
  texto2Novo6: "Νέες προκλήσεις κάθε μέρα",
  texto2Novo7: "Τακτικά ενημερωμένα παιχνίδια",
  tituloBloco3Novo: "Υψηλότερη βαθμολογία στην κατηγορία",
  tituloBloco4Novo: "Οφέλη για τη σχέση σας:",
  texto4Novo1: "Οικειότητα",
  texto4Novo2: "επιθυμία",
  texto4Novo3: "ελαφρότητα",
  texto4Novo4: "έλξη",
  texto4Novo5: "σύνδεση",
  texto4Novo6: "ευχαρίστηση",

  tituloBloco5Novo: "Τι λένε τα ζευγάρια",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Creo que esta es la mejor aplicación que he encontrado en el móvil hasta ahora, erótica e interesante. Todas las demás aplicaciones que he visto no se comparan, así que consigue un trabajo y cómprala. No te quejes porque estás en bancarrota. Te estás perdiendo cosas realmente buenas aquí, y $10.00 para tener toda la aplicación. Ofrece mejores experiencias que los juegos que encuentras en las tiendas de placer locales.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "¡Esta aplicación es increíble! Tenía dudas sobre si debía descargarla o no, pero sin duda fue la mejor sensación que hemos tenido en los últimos tiempos. Qué bueno es saber que todavía podemos hacer muchas cosas juntos. 🤭 Probamos la versión de pago y realmente vale la pena, no habíamos llegado a ese nivel de placer aún.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "¡Si quieres darle más sabor a la relación, esta aplicación es perfecta! Ya había probado otras, pero ninguna nos agradó tanto como esta. Nuestros juegos preliminares fueron mucho más calientes y placenteros (¡ahora imagina el resto!). Realmente vale la pena comprar la versión de pago (si quieres sentir un placer más intenso), pero la versión gratuita también sorprende.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "¡Excelente! Muy buena de verdad... Nos pusimos muy excitados durante el juego, lo que hizo que el sexo fuera mucho más apasionante, ¡fue placer por todas partes! Ya estamos ansiosos por jugar de nuevo 💦🔥. También recomendamos la versión de pago si pueden soportar tanta excitación 🤤.",
  tituloBloco6Novo:
    "Κάνετε όπως εκατοντάδες ζευγάρια σε όλο τον κόσμο και απογειώστε τη σχέση σας. Ανακαλύψτε περισσότερες από 800 νέες προκλήσεις!",
  texto6Select: "Επιλέξτε την έκδοση:",
  texto6Premium: "Premium",
  texto6Assinatura: "Υπογραφή",
  texto6Mensal: "Μηνιαία",
  texto6Anual: "Ετήσια",
  texto6Vitalicia: "Ισόβια άδεια",
  bePremium: "Γίνετε χρήστης Premium",
  buyNew: "Αγοράστε",
  attention: "Προσοχή!",
  changeGender: "Έχετε αλλάξει τον σεξουαλικό σας προσανατολισμό",

  tituloAvaliacao: "Σας αρέσει το παιχνίδι?",
  textoAvaliacao:
    "Βαθμολογήστε μας και βοηθήστε μας να συνεχίσουμε να βελτιώνουμε!",
  agoraNão: "Όχι τώρα",
  enviarAvaliacao: "Αποστολή",

  nomeJogo1: "Προκλήσεις για ερωτευμένους",
  nomeJogo2: "Αλήθεια ή Θάρρος ;!",
  nomeJogo3: "Επίπεδο καυτής ερωτικής διάθεσης",
  nomeJogo4: "Άτακτη Ρουλέτα",
  nomeJogo5: "Φράση της ημέρας",
  naughtyQuiz: "Τολμηρό κουίζ",

  playAlone: "Παίξτε μόνοι σας",
  estaSozinho: "Είστε μόνοι;",
  selectPlayer: "Επιλέξτε παίκτη",

  skip: "Παράλειψη",
  responder: "Αποστολή",
  respondaAqui: "Απαντήστε εδώ",
  config4: "Επιλογή avatar για προσαρμογή",

  tituloSelect1: "Παίζοντας μόνοι σας;",
  tituloSelect2: "Απάντηση σε δύσκολες ερωτήσεις!",

  subTituloSelect1: "Σας δίνουμε μια βοήθεια!",
  subTituloSelect2: "Ανακαλύψτε πόσο τολμηροί είστε!",
  txtJogador1:
    "Επιλέξτε τον παίκτη σας και εξερευνήστε καθοδηγούμενες ατομικές απολαύσεις σχεδιασμένες αποκλειστικά για εσάς!",
  txtJogador2: "The selected player will answer the questions",
  tituloCena: "ΠΟΙΑ ΕΙΔΗ ΘΕΛΕΤΕ ΝΑ ΧΡΗΣΙΜΟΠΟΙΗΣΕΤΕ;",
  subTituloCena: `Δεν διαθέτετε κάποιο; Αγγίξτε "Λήψη" και αποκτήστε το από το συνεργαζόμενο κατάστημα.`,
  play: "Παίξτε",

  titleUserWarning: "Επιλέξτε έναν χρήστη",
  txtUserWarning: "Ο επιλεγμένος παίκτης θα απαντήσει στις ερωτήσεις",

  shareNivelDeSafadeza:
    "Ψηφίστε, δείτε το επίπεδο ανακατωσιάς μου 😈 Ζήστε έντονες στιγμές ηδονής. Και εσείς 💋 Κατεβάστε την εφαρμογή τώρα και ετοιμαστείτε για καυτές προκλήσεις 🔥 με τον σύντροφό σας: ➡️ https://εφαρμογηπροκλησεων.page.link/sharelevelhot",

  shareDica:
    "Μεταμόρφωσε την ερωτική σου ζωή τώρα! Κατέβασε την εφαρμογή και ανακάλυψε το μυστικό μιας καυτής σχέσης: ➡️ https://εφαρμογηπροκλησεων.page.link/tipoftheday",

  resultadoQuiz1:
    "Είσαι ένας σεμνός άνθρωπος, δεν σου αρέσει πολύ το σέξ, προτιμάς κάτι πιο ρομαντικό!",
  resultadoQuiz2:
    "Είσαι υπερβολικά ρομαντικός για να υιοθετήσεις το σέξ και απολαμβάνεις περισσότερο την ατμόσφαιρα των κεριών.",
  resultadoQuiz3:
    "Είσαι ένα άτομο που πιστεύει στη διατήρηση των πραγμάτων στην ερωτική ζωή σου σε απόλυτη εχεμύθεια.",
  resultadoQuiz4:
    "Αυτό δεν σημαίνει ότι δεν είσαι κάποιες φορές ανήθικος, αλλά προτιμάς να κρατήσεις όλο αυτό το πάθος για να το μοιραστείς με κάποιον πολύ ξεχωριστό.",
  resultadoQuiz5:
    "Αυτό δεν σημαίνει ότι δεν είσαι κάποιες φορές ανήθικος, αλλά προτιμάς να κρατήσεις όλο αυτό το πάθος για να το μοιραστείς με κάποιον πολύ ξεχωριστό.",
  resultadoQuiz6:
    "Σου αρέσει να εξερευνείς νέες εμπειρίες, αλλά πάντα με σεβασμό και συναίνεση.",
  resultadoQuiz7:
    "Λατρεύεις ζεστές συναντήσεις γεμάτες φιλιά και χαδιά. Αλλά υπάρχει και μια πλευρά σου που απολαμβάνει να παρακολουθεί μια ταινία κρατώντας το χέρι του αγαπημένου/ης σου ή ένα δείπνο με κεριά.",
  resultadoQuiz8:
    "Είσαι πρόθυμος να δοκιμάσεις νέα και συναρπαστικά πράγματα, αλλά πάντα με ευθύνη.",
  resultadoQuiz9:
    "Είσαι τολμηρό άτομο και σου αρέσει να ανεβάζεις τη θερμοκρασία κατά καιρούς στην ερωτική σας ζωή.",
  resultadoQuiz10:
    "Σου αρέσει να απολαμβάνεις όλα τα απολαύσεις της ζωής και δεν έχεις όρια όταν πρόκειται για το σεξ.",
  resultadoQuiz11:
    'Μαζί σου, δεν υπάρχει κακή στιγμή, και κάθε στιγμή είναι κατάλληλη για γρήγορο σεξ! Ρομαντική ταινία; Μόνο αν πρόκειται για τα "50 αποχρώσεις του γκρι"!',
  resultadoQuiz12:
    "Για εσάς, η ερωτικότητα είναι μια συνεχής περιπέτεια, και δεν φοβάστε τους κινδύνους.",
  mes: "Μήνας",
  desafiosRestantesDois: "Έχετε 2 εναπομείναντα Premium προκλήσεις!",
  nenhumDesafioRestante: "Δεν υπάρχει καμία εναπομείνασα Premium πρόκληση!",
  tornePremiumAviso1:
    "Γίνετε τώρα premium και απολαύστε 1000 αποκλειστικές προκλήσεις!",
  tornePremiumAviso2:
    "Απολαύστε απεριόριστες προκλήσεις, αποκλειστικό περιεχόμενο και αδιάκοπη διασκέδαση!",
  conteudoPremium: "Επιλέξατε ένα Premium περιεχόμενο!",
  aproveite4desafios:
    "Απολαύστε 4 premium προκλήσεις για να δοκιμάσετε μια αποκλειστική απόλαυση.",
  calculando: "Υπολογισμός αποτελεσμάτων...",
  nivelRomantismo: "Το επίπεδο ρομαντισμού σας είναι...",
  finalizar: "Ολοκλήρωση",
  erroQuizTitulo: "Εισαγάγετε την απάντησή σας",
  erroQuizFrase: "Για να συνεχίσετε, εισαγάγετε την απάντησή σας!",
  new: "Νέο Εφαρμογή",

  //resposta quiz safadeza
  resQuiz1: "Ήπιος",
  resQuiz2: "Παθιασμένος",
  resQuiz3: "Εκλεπτυσμένος",
  resQuiz4: "Υπερβολικά άτακτος",

  texto6Semanal: "Εβδομαδιαίος",
  weekly: "Εβδομαδιαία Υπογραφή",

  tempSemanal: "Χρεώνεται εβδομαδιαία",
  tempMensal: "Χρεώνεται μηνιαία",
  tempAnual: "Χρεώνεται ετησίως",
  tempSempre: "Μονοαπληρωτική πληρωμή",
  canceleAny: "Ακυρώστε οποτεδήποτε",

  //Tela do safadrometro
  Low: "Χαμηλό",
  Medium: "Μεσαίο",
  High: "Υψηλό",

  lifeTime: "Δια βίου πρόσβαση",
  notNow: "Όχι τώρα, ευχαριστώ",
  match: "ΑΓΩΝΑΣ ΜΕ Α.Ι.",

  dateTitle: "Θέλετε να δείτε τη νέα μας εφαρμογή;",

  dateBody:
    "Θέλετε να συνομιλήσετε με άτακτα 😈 bots και να εξασκήσετε το φλερτ σας; Πρόκειται να περάσετε καλά!🔥",
  goToDate: "Δοκιμάστε το Date.AI τώρα!",

  goodForU: "ΉΤΑΝ ΚΑΛΟ ΓΙΑ ΕΣΑΣ;",
  rateOurPerformance: "Αξιολογήστε την απόδοσή μας μέχρι τώρα",
  veryGood: "Πολύ Καλό",
  veryBad: "Πολύ Κακό",
  feedbackChallenge: `Τι θα σε έκανε να μοιραστείς την εφαρμογή Hot Challenges με άλλα ζευγάρια και γιατί;`,
  type: "Πληκτρολογήστε την απάντησή σας εδώ...",
  survey: "Έρευνα ικανοποίησης.",
  shareIfConfortable: `Μη διστάσετε να το μοιραστείτε με φίλους αν αισθάνεστε άνετα :)`,

  howToPlay: "Πώς να παίξετε",
  howToPlayHotChallenge:
    "Ετοιμάσου να ανεβάσεις τη θερμοκρασία! Τράβηξε μια κάρτα πρόκλησης και ξάφνιασε τον/την σύντροφό σου με καυτή δράση!",

  preGameTip1:
    "Απελευθερώστε τις επιθυμίες σας και δημιουργήστε αξέχαστες στιγμές με τον σύντροφό σας!",
  preGameTip2: "Ανάψτε τα πάθη σας και δημιουργήστε αξέχαστες στιγμές μαζί!",
  preGameTip3:
    "Εξερευνήστε τις πιο άγριες επιθυμίες σας και δημιουργήστε αναμνήσεις που δεν θα ξεχάσετε ποτέ!",
  preGameTip4:
    "Απελευθερώστε τις φαντασιώσεις σας και απολαύστε στιγμές καθαρής απόλαυσης!",
  selecionajoagador: "Ώρα για παιχνίδι",
  dica: "Συμβουλή",

  howToPlayNaughty:
    "Επιλέξτε τα αγαπημένα σας παιχνίδια και αντικείμενα. Γυρίστε τον τροχό και αφήστε τη μοίρα να αποφασίσει την επόμενη πονηρή πρόκλησή σας!",
  howToPlayTruthOrDare:
    "Επίλεξε τη μοίρα σου: μοιράσου μια αλήθεια ή αποδέξου μια τολμηρή πρόκληση. Ας αρχίσει η διασκέδαση!",
  howToKama1: "Ανακαλύψτε Θέσεις Απόλαυσης – 365 Ημέρες Πάθους!",
  howToKama2:
    "Τράβηξε μια τυχαία κάρτα, δοκίμασε τη στάση και εξερευνήστε μαζί νέες κορυφές απόλαυσης!",
  kamaExplain:
    "Ξεκλειδώστε μια νέα στάση κάθε μέρα και χτίστε τη δική σας απόλυτη συλλογή πάθους – το ταξίδι σας για 365 ημέρες αξέχαστης απόλαυσης ξεκινά εδώ!",
  howToDo: "Πώς να το κάνετε",
  pergunta: "Ερώτηση",
  restart: "Επανεκκίνηση",
  dialogText1HotChallenges:
    "Ολοκληρώσατε όλες τις διαθέσιμες προκλήσεις με τις επιλεγμένες κατηγορίες.",
  dialogText2HotChallenges:
    "Επιλέξτε περισσότερες κατηγορίες ή επανεκκινήστε το παιχνίδι με τις τρέχουσες προκλήσεις!",
  noChallenges: "Χωρίς Προκλήσεις!",

  objects: "Αντικείμενα",
  dialogText1NaughtyGames:
    "Ολοκληρώσατε όλες τις διαθέσιμες προκλήσεις με τα επιλεγμένα αντικείμενα.",
  dialogText2NaughtyGames:
    "Επιλέξτε περισσότερα αντικείμενα ή επανεκκινήστε το παιχνίδι με τις τρέχουσες προκλήσεις!",
  unlockPremium: "Ξεκλείδωμα Premium",
  noCategory: "Παρακαλώ επιλέξτε τουλάχιστον μία κατηγορία για να ξεκινήσετε.",
  thanksForFeedback:
    "Ευχαριστούμε που μας βοηθάτε να βελτιώσουμε την εμπειρία!",
  categoryKamasutra: "Διάλεξε το πάθος σου και παίξε!",
  tap: "Πάτησε για να αποκαλύψεις τη στάση σου!",
  step: "Οδηγός Βήμα-Βήμα",
  shareQuizButton: "Μοιράσου το επίπεδο σκανδαλιάς σου!",
  tryAgain: "Δοκίμασε ξανά",
  unlockAllFun: "Ξεκλείδωσε όλη τη διασκέδαση",
  limitedOffer: "Ειδική προσφορά για περιορισμένο χρόνο!",
  fill: "Συμπληρώστε το όνομά σας και του/της συντρόφου σας.",

  kamaNotificationTitle: "🔥 Η νέα σας κάρτα ξεκλειδώθηκε!",
  kamaNotificationBody:
    "Η στάση σου για την ημέρα {variavel} είναι έτοιμη. Τι θα έλεγες να δοκιμάσεις κάτι καινούργιο σήμερα; 💋",

  titleNewGame: "Ετοιμαστείτε για Roleplay!",
  phraseNewGame:
    "Στην επόμενη ενημέρωση, ένα νέο παιχνίδι για να εξερευνήσετε τις πιο δημιουργικές φαντασιώσεις σας έρχεται. Επιλέξτε χαρακτήρες, δημιουργήστε ιστορίες και ανεβάστε τη διασκέδαση σε νέο επίπεδο με τον σύντροφό σας. 🔥",
  awaitNewGame: "Περιμένετε και ετοιμαστείτε να ζήσετε μοναδικές στιγμές!",
  selectObjects:
    "Επιλέξτε δύο ή περισσότερα αντικείμενα για να προσαρμόσετε το παιχνίδι σας. Εξερευνήστε στο έπακρο.",
  soon: "Σύντομα",
  wantToBeNotify: "Θέλω να ειδοποιηθώ.",
  ok: "Εντάξει",
  vezDe: "ΓΥΡΟΣ",

  categoryLabel: "Κατηγορία",
  descriptionLabel: "Περιγραφή",

  loginConnect: "Σύνδεση",
  loginNoAccount: "Δεν έχετε λογαριασμό;",
  loginCreateNow: "Δημιουργήστε τώρα",
  loginOrConnect: "ή συνδεθείτε με",

  email: "Email",
  password: "Κωδικός πρόσβασης",
  loginRegister: "Εγγραφή",
  loginAlreadyHas: "Έχετε ήδη λογαριασμό;",
  enterNow: "Εισαγωγή τώρα",

  logout: "Αποσύνδεση",
  customerPortal: "Πύλη Πελάτη",
  installApp: "Εγκατάσταση Εφαρμογής",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/grego.mp4",
};
